import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { getApi } from "../utils/api.ts";
import { API_GET_LEAVE_BALANCE_V2 } from "../../config/Endpoints";

type LeaveBalanceResponse = {
  wfh: { total: number; used: number; balance: number };
  cl: { total: number; used: number; balance: number };
  pl: { total: number; used: number; balance: number };
};

export const useLeaveBalance = () => {
  const [data, setData] = useState<LeaveBalanceResponse | null>(null);
  const [loading, setLoading] = useState(true);

  const accessToken = Cookies.get("accessToken");

  useEffect(() => {
    const fetchLeaveBalance = async () => {
      try {
        const res = await getApi<{ data: LeaveBalanceResponse }>(
          API_GET_LEAVE_BALANCE_V2,
          accessToken
        );

        setData(res.data.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaveBalance();
  }, [accessToken]);

  return { data, loading };
};